"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
const tslib_1 = require("tslib");
const types_1 = require("../types");
const get_1 = require("./get");
const getLiveSpaceData_1 = require("./helpers/getLiveSpaceData");
function initialize(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { spaceId } = options || {};
        const space = yield (0, get_1.get)({
            spaceId,
            env: this.env,
        });
        let liveSpaceData = this.spaceSpecificData.liveSpaceData;
        // if the space is active then fetch the latest meta message and update the live space data state
        if (space.status === types_1.ChatStatus.ACTIVE) {
            liveSpaceData = yield (0, getLiveSpaceData_1.default)({
                localAddress: this.data.local.address,
                spaceId,
                pgpPrivateKey: this.pgpPrivateKey,
                env: this.env,
            });
        }
        this.setSpaceSpecificData(() => (Object.assign(Object.assign({}, space), { liveSpaceData })));
    });
}
exports.initialize = initialize;
//# sourceMappingURL=initialize.js.map